export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "fr": {
        "no_seller_email_label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pas d'adresse email vendeur pour ce magasin"])}
      },
      "en": {
        "no_seller_email_label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["No seller email address for this store"])}
      }
    }
  })
}
